import { useEffect } from "react";
import useMethodSystem from "../useMethodSystem";

export default function TypeSelection() {
  const { next, type } = useMethodSystem();

  const rampTypes = [
    {
      id: 'onramp',
      name: 'On-Ramp',
      description:
        'Convert fiat to crypto using traditional payment methods such as bank transfers, credit cards, or digital wallets through standard ramp providers.'
    },
    {
      id: 'offramp',
      name: 'Off-Ramp',
      description:
        'Convert crypto back to fiat and withdraw funds to your bank account or preferred payment method using traditional ramp services.'
    },
    {
      id: 'checkout',
      name: 'Checkout',
      description:
        'Use one token to purchase another token without an AMM. This option supports direct blockchain transactions via smart contracts, DEXs, or other on-chain mechanisms.'
    }
  ];

  useEffect(() => {
    if(type) next(type);
  }, [type]);




  return (<div className=" ">
    <h2 className="text-2xl font-bold mb-4 text-center">Select Ramp Type</h2>
    <div className="grid gap-6 max-w-4xl mx-auto">
      {rampTypes.map((type) => (
        <div
          key={type.id}
          className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 border border-gray-200 cursor-pointer hover:border-blue-300"
          onClick={() => next(type.id)}
        >
          <h3 className="text-xl font-semibold mb-3 text-gray-800">
            {type.name}
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {type.description}
          </p>
        </div>
      ))}
    </div>
  </div>);
}